import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';
import Auth from "../../../libs/Auth";
import config from "../../../../../config";

export function* fetchFiles(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/files/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
    }
  });
  yield put({
    // $global: true,
    type: 'SET_FILES',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* downloadFile(action) {
  const { payload, meta } = action;

  const { file } = payload;

  const token = Auth.getToken();

  let filename = file.name || file.filename;
  filename = (filename.match(/[^ ]+/) || [])[0] + (filename.match(/\.[^.]+$/) || [])[0];

  const url = `${config.api.default}/files/download/${filename.replace(/ /g, '_').substr(0, 25)}?id=${file._id}&token=${encodeURIComponent(token)}`;
  window.location = url;
}


export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_FILES', fetchFiles),
    takeFirst('DOWNLOAD_FILE', downloadFile),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/Files.sagas.js